var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSignOutActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_9154_3302)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.7713 26.9034V28.4982C15.7713 29.7771 15.1339 30.8811 14.0264 31.5205C13.4935 31.8281 12.8987 31.9997 12.2821 32.0001C11.6649 32.0004 11.0704 31.8284 10.5371 31.5205L3.44611 27.4265C2.33842 26.787 1.70117 25.6833 1.70117 24.4042V3.48988C1.70117 1.56544 3.26667 0 5.19105 0H20.808C22.7325 0 24.2981 1.56531 24.2981 3.48988V7.89856C24.2981 8.531 23.7846 9.0445 23.1522 9.0445C22.5195 9.0445 22.0065 8.53106 22.0065 7.89856V3.48988C22.0065 2.82906 21.4688 2.29137 20.808 2.29137H7.12348L14.0264 6.27744C15.1335 6.91681 15.7713 8.02056 15.7713 9.29912V24.6118H20.808C21.4687 24.6118 22.0065 24.0744 22.0065 23.4136V19.5488C22.0065 18.9159 22.5192 18.4029 23.1522 18.4029C23.7849 18.4029 24.2981 18.9161 24.2981 19.5488V23.4136C24.2981 25.3381 22.7325 26.9034 20.808 26.9034H15.7713ZM26.389 14.5974L25.127 15.8593C24.6796 16.3067 24.6797 17.0321 25.127 17.4796C25.2334 17.5861 25.3597 17.6705 25.4987 17.7281C25.6377 17.7856 25.7868 17.8151 25.9372 17.8149C26.0878 17.8152 26.2369 17.7857 26.376 17.7282C26.5151 17.6706 26.6414 17.5862 26.7477 17.4796L29.9652 14.2616C30.4125 13.8142 30.4125 13.0893 29.9652 12.6419L26.7477 9.42437C26.3002 8.97687 25.5748 8.97706 25.1271 9.42431C24.6798 9.87131 24.6799 10.597 25.1271 11.0441L26.389 12.3057H17.9352C17.3022 12.3057 16.7895 12.8187 16.7895 13.4517C16.7895 14.0848 17.3022 14.5974 17.9352 14.5974H26.389V14.5974Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_9154_3302"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSignOutActive);
export default __webpack_public_path__ + "static/media/Sign Out-Active.1ae2c6c21184973f4c0953612ae7e0ca.svg";
export { ForwardRef as ReactComponent };